import React from 'react'
import { useLocation } from 'react-router-dom';
import IdentityEntra from './IdentityEntra';
import IdentityAD from './IdentityAD';

export default function Step() {
  const location = useLocation();
  const { isAD= false, isEntra= false } = location?.state || {};
  return (
    <>
      { isEntra && <IdentityEntra /> }
      { isAD && <IdentityAD /> }
    </>
  )
}
